import { useEffect, useState } from "react";
import { AuthApi } from "../../api/Auth.api";
import Error from "../../models/Error.model";
import { ERROR_TYPE } from "../../commons/Const";
import { Container } from "./style";
import { useLocation, useNavigate } from "react-router-dom";

export default function CertificatePage() {

  const location = useLocation()
  const navigate = useNavigate()

  const [title, setTitle] = useState('')
  const [type, setType] = useState('')

  useEffect(() => { 
    if(location.state === null) return
    const type = location.state.type

    if(type === 'findId') setTitle('아이디 찾기')
    else if(type === 'resetPassword') setTitle('비밀번호 재설정')

    setType(type)
  }, [location])

  const certificate = () => {
    const { IMP } = window
      IMP.init('imp84428497');
      //IMP.init('imp10391932');
      

      /* 2. 본인인증 데이터 정의하기 */
      const data = {
        // merchant_uid: `mid_${new Date().getTime()}`,
        // company: '아임포트',
        // carrier: 'SKT',
        // name: '홍길동',
        // phone: '01012341234'
      };

      /* 4. 본인인증 창 호출하기 */
      IMP.certification(data, (response: any) => {
        const {
        success,
        merchant_uid,
        imp_uid,
        error_msg
      } = response;

      if (response.success) {
        checkCertificate(imp_uid)
        
      } else {
        alert(`본인인증 실패: ${error_msg}`);
      }
      });
  }

  const checkCertificate = (imp_uid: string) => {
    AuthApi.certification(imp_uid, type)
    .then(result => {
      if(type === 'findId') {
        navigate({pathname: '/find-id'}, {state: {uid: result.uid, token: result.token}})
      }
      else if(type === 'resetPassword') {
        navigate({pathname: '/reset-password'}, {state: {uid: result.uid, token: result.token}})
      }
    }).catch(error => {
      console.error(error)
      if(error instanceof Error) {
        switch (error.code) {
          case ERROR_TYPE.NOT_SIGNUP_EMAIL:
            alert('해당 번호는 소셜 계정으로 가입되어 있습니다.')  
            break;
          case ERROR_TYPE.NOT_EXIST_USER:
            alert('해당 번호로 가입된 계정이 없습니다.')  
            break;
          default:
            break;
        }
      }
    })
  }

  return (
    <Container>
      <div className="inner page_inner">
        <section>
          <p className="page_title"><span>{title}</span></p>
          <p className="form_label">본인인증</p>
          <button className="contained_light_green btn_certification"
            onClick={certificate}
          >인증하기</button>
        </section>
      </div>
    </Container>
  )
}